export default "__VITE_ASSET__BJQIVYiH__"